




























































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Components
import ClientBillingBasicConfigurationComp from "@/components/app/global/client/clientBillingBasicConfigurationComp.vue";
import ClientInvoiceConsolidationComp from "@/components/app/global/client/clientInvoiceConsolidationComp.vue";
import ClientTaxTypeComp from "@/components/app/global/client/clientTaxTypeComp.vue";
import ClientDueDateComp from "@/components/app/global/client/clientDueDateComp.vue";

// Mixins
import Context from "@/mixins/context";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-billing-basic-configuration-comp": ClientBillingBasicConfigurationComp,
    "client-invoice-consolidation-comp": ClientInvoiceConsolidationComp,
    "client-tax-type-comp": ClientTaxTypeComp,
    "client-due-date-comp": ClientDueDateComp
  }
})
export default class ClientBillingSettings extends Mixins(Context) {
  // Refs

  public declare $refs: {
    billingBasicForm: ClientBillingBasicConfigurationComp;
    billingConsolidationForm: ClientInvoiceConsolidationComp;
    billingTaxTypeForm: ClientTaxTypeComp;
    billingDueDateForm: ClientTaxTypeComp;
  };

  // Props

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: false })
  public isSticky!: boolean;

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: string;

  // Data

  public isEnabled = {
    billingBasicForm: false,
    billingConsolidationForm: false,
    billingTaxTypeForm: false,
    billingDueDateForm: false
  };
  public isProcessing = {
    billingBasicForm: false,
    billingConsolidationForm: false,
    billingTaxTypeForm: false,
    billingDueDateForm: false
  };
  public refresh = this.initiateRefresh();

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.billingBasicForm.validateBeforeSubmit();
    this.$refs.billingConsolidationForm.validateBeforeSubmit();
    this.$refs.billingTaxTypeForm.validateBeforeSubmit();
    this.$refs.billingDueDateForm.validateBeforeSubmit();
  }

  public revertToInitialState() {
    this.$refs.billingBasicForm.revertToInitialState();
    this.$refs.billingConsolidationForm.revertToInitialState();
    this.$refs.billingTaxTypeForm.revertToInitialState();
    this.$refs.billingDueDateForm.revertToInitialState();
  }

  public initiateRefresh() {
    return {
      billingBasicForm: false,
      billingConsolidationForm: false,
      billingTaxTypeForm: false,
      billingDueDateForm: false
    };
  }

  // Computed

  public get showFormControls() {
    return this.isSticky && _.values(this.isEnabled).includes(true);
  }

  public get showIsProcessingState() {
    return _.values(this.isProcessing).includes(true);
  }

  // Watchers

  @Watch("refresh", { deep: true })
  public onRefreshChange() {
    if (_.values(this.refresh).includes(false)) return;

    this.$emit("refreshClient");

    this.$store.dispatch("toast/show", {
      message: this.$t("_sentence.billing_settings_updated")
    });

    this.refresh = this.initiateRefresh();
  }
}
